// extracted by mini-css-extract-plugin
export default {"container":"Education_container__D3cnQ","resumeSection":"Education_resumeSection__3QNn6"};